import { Shield } from 'lucide-react'
import { useConsent } from '../contexts/ConsentContext'

export function CookieBanner() {
  const { hasConsented, acceptCookies, rejectCookies } = useConsent()

  if (hasConsented !== null) return null

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-[60] bg-white border-t-2 border-[#1D71C3] shadow-2xl p-4 md:p-5"
      role="dialog"
      aria-label="Aviso de privacidade e cookies"
    >
      <div className="container flex flex-col md:flex-row items-start md:items-center gap-4">
        <div className="flex items-start gap-3 flex-1">
          <Shield className="text-[#1D71C3] mt-0.5 shrink-0" size={22} />
          <div>
            <p className="text-sm font-semibold text-gray-900 mb-1">Aviso de Privacidade (LGPD)</p>
            <p className="text-xs text-gray-600 leading-relaxed">
              Este site utiliza cookies e tecnologias similares para melhorar sua experiência e
              coletar dados de navegação de forma anônima, conforme a Lei Geral de Proteção de
              Dados (Lei 13.709/2018). Seus dados pessoais são tratados com responsabilidade e
              utilizados exclusivamente para fins de participação social e melhoria do projeto.
            </p>
          </div>
        </div>
        <div className="flex gap-2 shrink-0 w-full md:w-auto">
          <button
            onClick={rejectCookies}
            className="flex-1 md:flex-none px-4 py-2 text-sm font-medium text-gray-600 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
          >
            Recusar
          </button>
          <button
            onClick={acceptCookies}
            className="flex-1 md:flex-none px-4 py-2 text-sm font-semibold text-white bg-[#1D71C3] rounded-lg hover:bg-[#175FA3] transition-colors"
          >
            Aceitar
          </button>
        </div>
      </div>
    </div>
  )
}